// Libraries
import React, { useEffect } from 'react'
import { Avatar } from '@material-ui/core'

// Services
import { useStateValue } from 'context/store'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { _getProfileImage } from './actions'

// Images
import defaultUserPhoto from 'images/defaultUser.jpg'

function UserAvatar({ extraClass, onClick = () => {} }) {
   const [{ userAvatar = {} }, dispatch] = useStateValue()

   const getProfileImage = useApiRequest(
      () => _getProfileImage(dispatch),
      'Imagen de perfil: Consultar',
      false
   )

   useEffect(() => {
      if (!userAvatar.photo) {
         getProfileImage()
      }
   }, [])

   return (
      <Avatar
         onClick={onClick}
         src={userAvatar.photo ?? defaultUserPhoto}
         className={extraClass}
      />
   )
}

export default UserAvatar
